<template>
  <div class="pd-Listing_Product pd-Listing_Card">
    <div class="pd-Listing_ImageContainer">
      <div class="pd-Listing_ImageWrapper">
        <img :alt="item.image.alt" :src="item.image.url" class="pd-Listing_Image" />
      </div>
    </div>
    <div class="pd-Listing_Text">
      <div class="badge badge-secondary mb-1 mr-1">
        {{ item.badge }}
      </div>
      <a :href="item.link" class="stretched-link">
        <div class="pd-Listing_Title text-dark">{{ item.name }}</div>
      </a>
      <div class="pd-Listing_PriceArea mt-n1">
        <div class="pd-Listing_Price mt-1">
          <div class="sw-PriceTag_Price">{{ item.price | currency }}</div>
        </div>
      </div>
      <div
        class="pd-Listing_VendorInfo text-truncate d-none d-sm-block pd-Listing_VendorInfoOverlay"
      >
        {{ item.vendor }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductTile",
  props: {
    item: {
      required: true,
      type: Object,
    },
    lyticsActivities: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
